export default "__VITE_ASSET__c40cb882__"